import React, {useState} from 'react';
import Grid from '@mui/material/Grid2';
import {useTranslation} from "react-i18next";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import GetConfirmationButton from "../../../../components/elements/GetConfirmationButton";
import {Card, Switch, Typography} from "@mui/material";
import {CheckBoxRounded} from "@mui/icons-material";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {currencySymbol, getMediaURL, price, showSimpleDate} from "../../../../../config/values";
import Avatar from "@mui/material/Avatar";
import MakeDiscountCodeButton from "../MakeDiscountCodeButton";
import Box from '@mui/material/Box';
import {Trash, TicketPercent, SquareX, SquareCheckBig} from "lucide-react";

function DiscountCodeCard({classes,item,reload}){
    const { t } = useTranslation();
    const loginToken = localStorage.getItem('ACT');
    const [loading, setLoading] = useState(false);

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const handleDelete = (item_id) =>{
        setLoading(true);
        let data = new FormData();
        data.append('id', item_id);
        axios.post(`${defaultVariables.url}/discount-codes/delete`,data,config)
            .then(response => {
                setLoading(false);
                reload();

            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }
    const handleActive = (item_id) =>{

        let data = new FormData();
        data.append('id', item_id);
        axios.post(`${defaultVariables.url}/discount-codes/toggle-active`,data,config)
            .then(response => {
                reload();
            })
            .catch(error => {
                console.error("Error fetching item data:", error);

            });
    }
    return (
        <Card className="item-card">
            <Grid container spacing={2}>
                <Grid item size={12}>
                    <Box className={classes.categoryHold}>
                        <div className="details">
                                <TicketPercent/>
                            <div className="name-holder">
                                <Typography>
                                    <span className="code-title">{item.code}{" "}</span>
                                    {
                                        !!item.valid ?
                                            <Typography className="table-badge active">{t('valid')}</Typography>
                                            :
                                            <Typography className="table-badge inactive">{t('expired')}</Typography>
                                    }
                                </Typography>
                            </div>
                        </div>

                        <div className="actions actions-gap">
                            <MakeDiscountCodeButton item_id={item.id} reload={reload}/>
                            <Switch
                                size="small"
                                checked={item.active}
                                onChange={() => handleActive(item.id)}
                                color="secondary"
                            />
                            <GetConfirmationButton
                                handleAction={() => handleDelete(item.id)}
                                question={t('doYouWanaDeleteItem')}
                                icon={<CheckBoxRounded/>}
                                tooltip={t('delete')}
                                loading={loading}
                                iconColor="primary"
                            >
                                <Trash className="lucide-icon-primary btn"/>
                            </GetConfirmationButton>
                        </div>
                    </Box>
                    <Typography className="text-100">
                        {t('usedDiscounts')}:
                        {
                            item.quantity !== null ?
                                <span>{item.used} / {item.quantity}</span>
                                :
                                <span>{item.used} / {t('unlimited')}</span>
                        }

                    </Typography>

                    <Typography className="text-100">{t('value')}: <span>{price(item.amount)} {item.type === "fixed" ? currencySymbol : "%"}</span></Typography>

                    <Typography className="text-100">
                        {t('minimumOrderAmountCode')}:
                        {
                            !!item.minimum_order ?
                            <span>{price(item.minimum_order)} {currencySymbol}</span>
                                :
                                <span> - </span>
                        }
                    </Typography>
                    <Typography className="text-100">
                        {t('free_delivery_code')}
                        {
                            !!item.free_delivery ?
                                <span><SquareCheckBig className="lucide-icon-secondary"/></span>
                                :
                                <span><SquareX className="lucide-icon-gray"/></span>
                        }
                    </Typography>
                    <Typography className="text-100">
                        {t('for_first_order')}
                        {
                            !!item.for_first_order ?
                                <span><SquareCheckBig className="lucide-icon-secondary"/></span>
                                :
                                <span><SquareX className="lucide-icon-gray"/></span>
                        }
                    </Typography>
                    <Typography className="text-100">
                        {t('industry')}:
                        {
                            !!item.industry ?
                                <span>{t(item.industry)}</span>
                                :
                                <span>All</span>
                        }

                    </Typography>
                    <Typography className="text-100">
                        {t('valid_until')}:
                        {
                            !!item.valid_until ?
                                <span>{showSimpleDate(item.valid_until)}</span>
                                :
                                <span>{t('unlimited')}</span>
                        }

                    </Typography>


                </Grid>
            </Grid>
        </Card>
    );
}
export default withStyles(Styles)(DiscountCodeCard);
